import React from 'react';
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import QuestionnaireReadOnlyResponse from 'ts/common/components/questionnaire/QuestionnaireReadOnlyResponse';

const QuestionnaireCompletedView: React.FC<{
    sortedPages: SpApi.Client.IQuestionnairePage[];
}> = ({ sortedPages }) => {
    return (
        <Flex direction="column" gap="32px">
            {sortedPages.map((page, pageIdx) => (
                <Flex key={page.id} direction="column" gap="16px">
                    <Text as="h3" fontSize="18px" fontWeight="600">
                        {page.name}
                    </Text>
                    {[...page.questions]
                        .sort((a, b) => a.displayOrder - b.displayOrder)
                        .map((question) => (
                            <Box
                                key={question.id}
                                paddingX={{ base: '16px', lg: '40px' }}
                                paddingY="8px"
                            >
                                <Text fontSize="16px" marginBottom="8px">
                                    {question.questionText}
                                </Text>
                                <QuestionnaireReadOnlyResponse
                                    question={question}
                                    listMargin="0"
                                    listItemMarginLeft="-16px"
                                />
                            </Box>
                        ))}
                    {pageIdx < sortedPages.length - 1 && <Divider />}
                </Flex>
            ))}
        </Flex>
    );
};

export default QuestionnaireCompletedView;
